export class IllegalLocationStatus extends Error {
  constructor() {
    super('Cannot modify courtroom status while courthouse is archived')
    Object.setPrototypeOf(this, IllegalLocationStatus.prototype)
  }
}
